<template>
<div>
  <el-dialog
      v-model="dialogVisible"
      title="批量发送合同"
      width="1000">
    <el-table :data="list" style="width: 100%">
      <el-table-column prop="studentName" label="学员姓名" width="120" />
      <el-table-column prop="orderId" label="主卡ID" width="100" />
      <el-table-column width="180" label="所属区域">
        <template #default="scope">{{ scope.row.submitAreaName }}</template>
      </el-table-column>
      <el-table-column
          width="180"
          show-overflow-tooltip="true"
          label="所属校区"
      >
        <template #default="scope">{{ scope.row.submitCampusName + " - " + scope.row.submitCampusTypeName }}</template>
      </el-table-column>
      <el-table-column
          width="180"
          show-overflow-tooltip="true"
          label="上课校区"
      >
        <template #default="scope"
        >{{ scope.row.campusName != null ? scope.row.campusName + " - " + scope.row.classCampusTypeName : "" }}
        </template>
      </el-table-column>
      <el-table-column
          prop="contractState"
          align="center"
          label="合同状态"

      >
        <template v-slot="products">
          <span>{{ products.row.htStateName }}</span>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="start">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</div>
</template>

<script>
import {sendContract,createdContract} from "../../../api/orders";
export default {
  name: "SendContract",
  props: {

  },
  data() {
    return {
      list: [],
      dialogVisible:false
    }
  },
  methods:{
    openDialog(list){
      this.list = JSON.parse(JSON.stringify(list));
      this.dialogVisible = true;
    },
    async start() {
      // 使用for...of循环替代forEach，确保异步操作按顺序执行
      for (let [index, item] of this.list.entries()) {
        await this.createdContract(item.orderId, index);
        await this.sendContract(item.orderId, index);
      }
      this.$emit('refresh');
    },

    async sendContract(orderId, index) {
      if (this.list[index].htStateName == '生成异常！'){
        return;
      }else {
        this.list[index].htStateName = "发送中";
      }
      // 统一使用async/await，避免和.then()混合
      try {
        const val = await sendContract(orderId);
        if (val.code === 200) {
          this.list[index].htStateName = "发送成功！";
        } else {
          this.list[index].htStateName = "发送异常！";
        }
      } catch (error) {
        // 捕获可能的网络错误等异常
        this.list[index].htStateName = "发送异常！";
        console.error("发送失败:", error);
      }
    },

    async createdContract(orderId, index) {
      this.list[index].htStateName = "生成中！";
      try {
        const val = await createdContract(orderId);
        if (val.code === 200) {
          this.list[index].htStateName = "生成成功！";
        } else {
          this.list[index].htStateName = "生成异常！";
        }
      } catch (error) {
        this.list[index].htStateName = "生成异常！";
        console.error("生成失败:", error);
      }
    }
  }
}
</script>

<style scoped>

</style>